module.exports = __webpack_public_path__ + "static/img/active8.7009cce8.png";